// WTC pod phase (event.flags.wtcPodPhase): the pod and seed of a team on the organizer roster.

const hasNumber = (value) => typeof value === "number" && !Number.isNaN(value);

// "Pod #08 - seed 3"; empty when the team has no pod. A team with a pod and no seed shows only the pod.
export const getPodSeedLabel = (team) => {
  if (!hasNumber(team?.podNum) || team.podNum < 1) return "";
  const pod = `Pod #${String(team.podNum).padStart(2, "0")}`;
  return hasNumber(team?.bracket_seed)
    ? `${pod} - seed ${team.bracket_seed}`
    : pod;
};

// The pod numbers that exist on the roster, ascending.
export const getPodNumbers = (teams) =>
  [
    ...new Set(
      (teams || [])
        .map((team) => team?.podNum)
        .filter((podNum) => hasNumber(podNum) && podNum >= 1)
    )
  ].sort((a, b) => a - b);

// The teams of one pod ("" or undefined: all of them).
export const filterByPod = (teams, pod) =>
  pod === "" || pod === undefined || pod === null
    ? teams
    : (teams || []).filter((team) => team?.podNum === Number(pod));

// Pod, then seed, then name; teams without a pod last. Returns a new array.
export const sortByPodSeed = (teams) =>
  [...(teams || [])].sort((a, b) => {
    const aPod = hasNumber(a?.podNum) && a.podNum >= 1;
    const bPod = hasNumber(b?.podNum) && b.podNum >= 1;
    if (aPod !== bPod) return aPod ? -1 : 1;
    if (aPod && a.podNum !== b.podNum) return a.podNum - b.podNum;
    const aSeed = hasNumber(a?.bracket_seed);
    const bSeed = hasNumber(b?.bracket_seed);
    if (aSeed !== bSeed) return aSeed ? -1 : 1;
    if (aSeed && a.bracket_seed !== b.bracket_seed)
      return a.bracket_seed - b.bracket_seed;
    return String(a?.name || "").localeCompare(String(b?.name || ""));
  });
